import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HttpCommonService} from '../../../../../shared/services/http-common.service';
import {Observable} from 'rxjs';
import {PropuestaComercialArchivo} from './propuesta-comercial-archivos.interface';

@Injectable({
  providedIn: 'root'
})
export class PropuestaComercialArchivosService {

  private http = inject(HttpClient);
  private httpCommonService = inject(HttpCommonService);
  private apiUrl = this.httpCommonService.makeUrl('/crms/propuestasComerciales/archivos');

  index(idPropuesta: number): Observable<{ status: boolean, data: PropuestaComercialArchivo[] }> {
    return this.http.get<{ status: boolean, data: PropuestaComercialArchivo[] }>(
      this.apiUrl,
      {params: {crm_propuesta_comercial_id: idPropuesta}}
    );
  }

  store(formData: FormData): Observable<{ status: boolean, data: PropuestaComercialArchivo }> {
    return this.http.post<{ status: boolean, data: PropuestaComercialArchivo }>(this.apiUrl, formData);
  }

  show(id: number): Observable<{ status: boolean, data: PropuestaComercialArchivo }> {
    return this.http.get<{ status: boolean, data: PropuestaComercialArchivo }>(`${this.apiUrl}/${id}`);
  }

  update(id: number, data: { descripcion?: string }): Observable<{ status: boolean, data: PropuestaComercialArchivo }> {
    return this.http.put<{ status: boolean, data: PropuestaComercialArchivo }>(`${this.apiUrl}/${id}`, data);
  }

  destroy(id: number): Observable<{ status: boolean, data: PropuestaComercialArchivo }> {
    return this.http.delete<{ status: boolean, data: PropuestaComercialArchivo }>(`${this.apiUrl}/${id}`);
  }

  download(id: number): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/${id}/descargar`, {responseType: 'blob'});
  }
}
